/**
 * Table Colors Control Group - Main Export File
 *
 * This module exports the Table Colors utilities for use throughout the Redfox Thank You plugin.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

// Export TypeScript interfaces and types
export type { TableColorsAttributes, TableColorsValues } from '../types';

// Export style functions
export { generateTableColorsCSSRules, getTableColorsCSS } from './style';
